import {Admin} from '@/types';
import { api, tokenApi } from '@/api';
import cookies from 'js-cookie';
import JwtDecode from 'jwt-decode';
import store from '../store';
import { SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN, TOKEN_EXPIRE_TIME, SESSION_INITIALIZE } from '@/const/words/cookie';
import {PostAuthTokenRequest} from 'supporter';

export async function setToken(accessToken: string, refreshToken: string, autoLogoutMin: number): Promise<Admin> {
  let admin: Admin = null;
  try {
    admin = JwtDecode(accessToken);
  } catch {
    alert(window.$t('COMMON_SERVER_ERROR_MSG'));
    window.location.href = '/login';
  }
  if (admin) {
    api.axios.defaults.headers.accessToken = accessToken;
    cookies.set(SHOPBY_ACCESSTOKEN, accessToken, { expires: (1.0 / 24 / 60) * 30 }); // 30분
    cookies.set(SHOPBY_REFRESHTOKEN, refreshToken, { expires: (1.0 / 24 / 60) * autoLogoutMin }); // autoLogoutMin 분
    cookies.set(TOKEN_EXPIRE_TIME, autoLogoutMin.toString(), { expires: 1.0 }); // 1d

    await store.dispatch('admin/setAdmin', admin);
    return admin;
  }
}
export const setSessionCookie = () => {
  cookies.set(SESSION_INITIALIZE, SESSION_INITIALIZE); //브라우저 종료 여부 확인
};

export async function refreshToken(): Promise<boolean> {
  let refreshToken = cookies.get(SHOPBY_REFRESHTOKEN);
  if (refreshToken && refreshToken.length) {
    const request: PostAuthTokenRequest = {
      data: {
        adminType: 'SERVICE',
        grantType: 'REFRESH_TOKEN',
        refreshToken
      }
    };
    try {
      const response = await tokenApi.postAuthToken(request);
      const {data} = response;
      setToken(data.accessToken, data.refreshToken, data.autoLogoutMin);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}

/**
 * API 호출 시 RT 만료시간을 로컬에서 연장함
 * RT 의 만료시간은 서버에서는 24시간이고, 프론트에서는 autoLogoutMin 를 사용하는 것이 보안정책
 * 최초 토큰발급 24시간 후에는 서버에서 만료 시킴
 */
export function refreshTokenCalledApi(): void {
  const refreshToken = cookies.get(SHOPBY_REFRESHTOKEN);
  const autoLogoutMin = Number(cookies.get(TOKEN_EXPIRE_TIME)) || 60;

  if (!refreshToken || !refreshToken.length) {
    return;
  }

  cookies.set(SHOPBY_REFRESHTOKEN, refreshToken, { expires: (1.0 / 24 / 60) * autoLogoutMin }); // autoLogoutMin 분
}
